import React from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { OnlyContinueButton } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import ItemTypeSet from 'components/base/ItemTypeSet';
import { POINT_RECORD_TYPE } from 'config/CustomEnums';
import { validate } from 'containers/record/pointRecords/CreatePorintRecordValidate';

import AddPointIcon from 'assets/images/pointRecord/addPoint.svg';
import RemovePointIcon from 'assets/images/pointRecord/removePoint.svg';

import './CreatePointRecordStepOne.scss';

const POINT_TYPE_CONFIG = [
  {
    id: POINT_RECORD_TYPE.TYPE_ADD,
    title: 'Add Point',
    image: AddPointIcon,
    description: 'Points will be given to customers',
  },
  {
    id: POINT_RECORD_TYPE.TYPE_REMOVE,
    title: 'Remove Point',
    image: RemovePointIcon,
    description: 'Deduct points from customers',
  },
];

function CreatePointRecordStepOne() {
  const dispatch = useDispatch();
  const { watch, getValues, setValue, clearErrors, setError } =
    useFormContext();

  const pointTypeField = 'pointType';
  const selectedType = watch(pointTypeField);

  const stepChangeAction = () => {
    const isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 0,
      isBack: false,
    });
    dispatch({
      type: 'createPointRecord/stepChange',
      payload: {
        isBack: false,
        step: 0,
        isValid: isValid,
      },
    });
  };

  const sections = [
    <div className="create-point-step-one-title">
      <label className="step-one-title">Event Type</label>
      <div className="point-record-step-type-area">
        {POINT_TYPE_CONFIG.map((item) => {
          return (
            <ItemTypeSet
              key={item.id}
              moreThanThree={false}
              item={item}
              selected={selectedType}
              onClick={(id) => {
                setValue(pointTypeField, id, { shouldDirty: true });
              }}
              selectedType={selectedType}
            />
          );
        })}
      </div>
    </div>,
  ];
  return (
    <>
      <ContentSections sections={sections} hidePreview={true} />
      <OnlyContinueButton
        continueAction={() => {
          stepChangeAction();
        }}
        disabledContinue={!selectedType}
      />
    </>
  );
}

const mapPropsToState = (state) => ({});

export default connect(mapPropsToState)(CreatePointRecordStepOne);
